import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminLayout } from './components/layout/AdminLayout';
import { LoginPage } from './pages/Login/LoginPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { ChatLogsPage } from './pages/Logs/ChatLogsPage';
import { ChatLogDetailPage } from './pages/Logs/ChatLogDetailPage';
import { FaqListPage } from './pages/Faq/FaqListPage';
import { FaqFormPage } from './pages/Faq/FaqFormPage';
import { ChatMessagesPage } from './pages/ChatMessages/ChatMessagesPage';
import { SymptomListPage } from './pages/Symptom/SymptomListPage';
import { SymptomFormPage } from './pages/Symptom/SymptomFormPage';
import { BulkUploadPage } from './pages/BulkUpload/BulkUploadPage';
import { UserListPage } from './pages/Users/UserListPage';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/logs/chat" element={<ChatLogsPage />} />
              <Route path="/logs/chat/:id" element={<ChatLogDetailPage />} />
              <Route path="/faq" element={<FaqListPage />} />
              <Route path="/faq/new" element={<FaqFormPage />} />
              <Route path="/faq/:id/edit" element={<FaqFormPage />} />
              <Route path="/chat-messages" element={<ChatMessagesPage />} />
              <Route path="/symptoms" element={<SymptomListPage />} />
              <Route path="/symptoms/new" element={<SymptomFormPage />} />
              <Route path="/symptoms/:categoryId/:symptomName/edit" element={<SymptomFormPage />} />
              <Route path="/bulk-upload" element={<BulkUploadPage />} />
              <Route path="/users" element={<UserListPage />} />
              <Route
                path="*"
                element={
                  <div className="py-12 text-center">
                    <h1 className="mb-2 text-2xl font-bold text-slate-900">
                      ページが見つかりません
                    </h1>
                    <Link to="/" className="text-blue-600 hover:text-blue-800">
                      ダッシュボードに戻る
                    </Link>
                  </div>
                }
              />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};
